unit Essentials.Web.CustomNames.Editor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, WEBLib.Lists,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls,
  WEBLib.Dialogs, Data.DB, WEBLib.DB, Essentials.Web.BaseEditForm, Grid.Plugins,
  WEBLib.ExtCtrls, Web, WebLib.WebCtrls,   XData.Web.Connection,
  XData.Web.Client, Types, XData.Web.Dataset, JS;

type
  TEssentialsCustomNameEditor = class(TCoreWebForm)
    AddButton: TButton;
    cbPageSize: TComboBox;
    ConfirmationMsg: TMessageDlg;
    EssentialsTable: TDBTableControl;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    DataSource: TDataSource;
    procedure AddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure DataSourceStateChange(Sender: TObject);
  private
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    procedure DeactivateActiveForEntityField(const AEntityClassName, AFieldName: string;
      AExcludeId: Integer);
    function FindActiveCustomNameForEntityField(const AEntityClassName, AFieldName: string;
      AExcludeId: Integer): string;
    const RECORD_ID_DELIMITER = ';';
  protected
    FIdField: string;
    FGridPlugin: TGridPlugin;
    [Async]
    procedure AddRecord; async;
    [Async]
    procedure EditRecord(ARecordId: string); async;
    [Async]
    procedure ToggleActiveRecord(ARecordId: string); async;
    [Async]
    procedure Save; async;
    procedure RefreshControls(aShow: Boolean);
    function GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
    function ConvertIdFieldsIntoRecords(aIdFields: string): string;
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsCustomNameEditor: TEssentialsCustomNameEditor;

implementation

uses Essentials.Web.Shared, SMX.Web.Layout.Utils, SMX.webcore.Types,
StrUtils, XData.Web.JsonDataset, Essentials.Web.CustomNames.EditValueForm;

{$R *.dfm}

procedure TEssentialsCustomNameEditor.AddButtonClick(Sender: TObject);
begin
//  inherited;
  AddRecord;
end;

procedure TEssentialsCustomNameEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
  SetHtmlElementVisible('essentials.customnames.PageSizeRow', aShow);
end;

procedure TEssentialsCustomNameEditor.Save;
begin
  Await(Boolean, EssentialsManager.CustomNamesManager.SaveChanges);
end;

procedure TEssentialsCustomNameEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsCustomNameEditor.DeactivateActiveForEntityField(const AEntityClassName,
  AFieldName: string; AExcludeId: Integer);
begin
  DataSource.DataSet.DisableControls;
  try
    DataSource.DataSet.First;
    while not DataSource.DataSet.Eof do
    begin
      if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, AEntityClassName) and
         SameText(DataSource.DataSet.FieldByName('FieldName').AsString, AFieldName) and
         DataSource.DataSet.FieldByName('IsActive').AsBoolean and
         ((AExcludeId = 0) or (DataSource.DataSet.FieldByName('Id').AsInteger <> AExcludeId)) then
      begin
        DataSource.DataSet.Edit;
        DataSource.DataSet.FieldByName('IsActive').AsBoolean := False;
        DataSource.DataSet.Post;
      end;
      DataSource.DataSet.Next;
    end;
  finally
    DataSource.DataSet.EnableControls;
  end;
end;

function TEssentialsCustomNameEditor.FindActiveCustomNameForEntityField(const AEntityClassName,
  AFieldName: string; AExcludeId: Integer): string;
begin
  Result := '';
  DataSource.DataSet.First;
  while not DataSource.DataSet.Eof do
  begin
    if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, AEntityClassName) and
       SameText(DataSource.DataSet.FieldByName('FieldName').AsString, AFieldName) and
       DataSource.DataSet.FieldByName('IsActive').AsBoolean and
       ((AExcludeId = 0) or (DataSource.DataSet.FieldByName('Id').AsInteger <> AExcludeId)) then
      Exit(DataSource.DataSet.FieldByName('CustomName').AsString);
    DataSource.DataSet.Next;
  end;
end;

procedure TEssentialsCustomNameEditor.AddRowActions(const ARecordId: string;
  AParentElement: TJSHTMLElement);
  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);
  end;

  procedure ToggleActiveClick(Sender: TObject);
  begin
    ToggleActiveRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
  lIsActive: Boolean;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'View');
  Span.OnClick := @EditClick;

  lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
  if lIsActive then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Disable');
    Span.OnClick := @ToggleActiveClick;
  end
  else
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-check-circle', 'Enable');
    Span.OnClick := @ToggleActiveClick;
  end;
end;

procedure TEssentialsCustomNameEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

function TEssentialsCustomNameEditor.ConvertIdFieldsIntoRecords(aIdFields: string): string;
var
  idFieldsArr: TArray<string>;
  idField: string;
begin
    idFieldsArr := aIdFields.Split([RECORD_ID_DELIMITER]);
    Result := '';
    for idField in idFieldsArr do
      Result := IfThen(Result <> '', Result + RECORD_ID_DELIMITER, '') + DataSource.DataSet.FieldByName(idField).AsString;
end;

procedure TEssentialsCustomNameEditor.DataSourceStateChange(Sender: TObject);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

function TEssentialsCustomNameEditor.GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
var
  recordIds: TArray<string>;
  i, arrLength: Integer;
begin
  recordIds := aRecordIds.Split([RECORD_ID_DELIMITER]);
  arrLength := Length(recordIds);
  SetLength(Result, arrLength);

  for i := 0 to arrLength - 1 do
    Result[i] := recordIds[i];
end;

procedure TEssentialsCustomNameEditor.ToggleActiveRecord(ARecordId: string);
var
  foundRecord: Boolean;
  lIsActive: Boolean;
  lName, lMsg, lEntityClassName, lFieldName, lOtherActiveName: string;
  lRecordId: Integer;
begin
  if ARecordId.Contains(RECORD_ID_DELIMITER) then
    foundRecord := DataSource.DataSet.Locate(FIdField, GetJSArrayFromRecordIds(ARecordId), [])
  else
    foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord then
  begin
    lRecordId := DataSource.DataSet.FieldByName('Id').AsInteger;
    lIsActive := DataSource.DataSet.FieldByName('IsActive').AsBoolean;
    lName := DataSource.DataSet.FieldByName('CustomName').AsString;
    lEntityClassName := DataSource.DataSet.FieldByName('EntityClassName').AsString;
    lFieldName := DataSource.DataSet.FieldByName('FieldName').AsString;

    if lIsActive then
    begin
      ConfirmationMsg.Title := 'Disable';
      lMsg := Format('Are you sure you want to disable %s? The field will revert to its standard label.', [QuotedStr(lName)]);
    end
    else
    begin
      lOtherActiveName := FindActiveCustomNameForEntityField(lEntityClassName, lFieldName, lRecordId);
      ConfirmationMsg.Title := 'Enable';
      if lOtherActiveName <> '' then
        lMsg := Format('Enabling %s will disable %s for %s.%s. Continue?',
          [QuotedStr(lName), QuotedStr(lOtherActiveName), lEntityClassName, lFieldName])
      else
        lMsg := Format('Are you sure you want to enable %s?', [QuotedStr(lName)]);
    end;

    if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
    begin
      if not lIsActive then
        DeactivateActiveForEntityField(lEntityClassName, lFieldName, lRecordId);

      if not DataSource.DataSet.Locate(FIdField, ARecordId, []) then
        Exit;

      DataSource.DataSet.Edit;
      DataSource.DataSet.FieldByName('IsActive').AsBoolean := not lIsActive;
      DataSource.DataSet.Post;
      Await(Save);
    end;
  end;
end;

procedure TEssentialsCustomNameEditor.AddRecord;
var
  AForm: TCustomNamesEditValue;
  lEntityClassName, lFieldName, lCustomName, lMsg, lOtherActiveName: string;
  lDeactivatedSameName, lActiveSameName: Boolean;
begin
  AForm := TCustomNamesEditValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TCustomNamesEditValue, AForm.Load());
    AForm.SetDataSources(DataSource.DataSet);
    DataSource.DataSet.Insert;
    AForm.LoadEntityList;
    AForm.EditMode := Add;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      lEntityClassName := DataSource.DataSet.FieldByName('EntityClassName').AsString;
      lFieldName := DataSource.DataSet.FieldByName('FieldName').AsString;
      lCustomName := DataSource.DataSet.FieldByName('CustomName').AsString;
      DataSource.DataSet.Cancel;

      lDeactivatedSameName := False;
      lActiveSameName := False;
      DataSource.DataSet.First;
      while not DataSource.DataSet.Eof do
      begin
        if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, lEntityClassName) and
           SameText(DataSource.DataSet.FieldByName('FieldName').AsString, lFieldName) and
           SameText(DataSource.DataSet.FieldByName('CustomName').AsString, lCustomName) then
        begin
          if DataSource.DataSet.FieldByName('IsActive').AsBoolean then
            lActiveSameName := True
          else
            lDeactivatedSameName := True;
        end;
        DataSource.DataSet.Next;
      end;

      if lActiveSameName then
      begin
        ConfirmationMsg.Title := 'Already Exists';
        lMsg := Format('An active custom name %s already exists for %s.%s.', [QuotedStr(lCustomName), lEntityClassName, lFieldName]);
        Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtWarning, [mbOK]));
      end
      else if lDeactivatedSameName then
      begin
        lMsg := Format('A disabled custom name %s already exists for %s.%s. Would you like to enable it instead?',
          [QuotedStr(lCustomName), lEntityClassName, lFieldName]);
        ConfirmationMsg.Title := 'Enable Existing';
        if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) = mrYes then
        begin
          lOtherActiveName := FindActiveCustomNameForEntityField(lEntityClassName, lFieldName, 0);
          if lOtherActiveName <> '' then
          begin
            lMsg := Format('Enabling %s will disable %s for %s.%s. Continue?',
              [QuotedStr(lCustomName), QuotedStr(lOtherActiveName), lEntityClassName, lFieldName]);
            if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) <> mrYes then
              Exit;
          end;

          DeactivateActiveForEntityField(lEntityClassName, lFieldName, 0);
          DataSource.DataSet.First;
          while not DataSource.DataSet.Eof do
          begin
            if SameText(DataSource.DataSet.FieldByName('EntityClassName').AsString, lEntityClassName) and
               SameText(DataSource.DataSet.FieldByName('FieldName').AsString, lFieldName) and
               SameText(DataSource.DataSet.FieldByName('CustomName').AsString, lCustomName) and
               (not DataSource.DataSet.FieldByName('IsActive').AsBoolean) then
            begin
              DataSource.DataSet.Edit;
              DataSource.DataSet.FieldByName('IsActive').AsBoolean := True;
              DataSource.DataSet.Post;
              Break;
            end;
            DataSource.DataSet.Next;
          end;
          Await(Save);
        end;
      end
      else
      begin
        lOtherActiveName := FindActiveCustomNameForEntityField(lEntityClassName, lFieldName, 0);
        if lOtherActiveName <> '' then
        begin
          lMsg := Format('Adding %s will disable %s for %s.%s. Continue?',
            [QuotedStr(lCustomName), QuotedStr(lOtherActiveName), lEntityClassName, lFieldName]);
          if Await(TModalResult, ConfirmationMsg.ShowDialog(lMsg, mtConfirmation, [mbYes, mbNo])) <> mrYes then
            Exit;
          DeactivateActiveForEntityField(lEntityClassName, lFieldName, 0);
        end;

        DataSource.DataSet.Insert;
        DataSource.DataSet.FieldByName('EntityClassName').AsString := lEntityClassName;
        DataSource.DataSet.FieldByName('FieldName').AsString := lFieldName;
        DataSource.DataSet.FieldByName('CustomName').AsString := lCustomName;
        DataSource.DataSet.FieldByName('IsActive').AsBoolean := True;
        DataSource.DataSet.Post;
        Await(Save);
      end;
    end;
  finally
    if DataSource.DataSet.State in [dsInsert, dsEdit] then
      DataSource.DataSet.Cancel;
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsCustomNameEditor.EditRecord(ARecordId: string);
var
  AForm: TCustomNamesEditValue;
begin
  if Trim(ARecordId) = '' then
    Exit;

  if not DataSource.DataSet.Locate(FIdField, ARecordId, []) then
    Exit;

  AForm := TCustomNamesEditValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TCustomNamesEditValue, AForm.Load());
    AForm.SetDataSources(DataSource.DataSet);
    AForm.EditMode := None;
    AForm.LoadEntityList(False);

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      DataSource.DataSet.Post;
      Await(Save);
    end
  finally
    if DataSource.DataSet.State in [dsInsert, dsEdit] then
      DataSource.DataSet.Cancel;
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsCustomNameEditor.EssentialsTableGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := ConvertIdFieldsIntoRecords(FIdField);

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;

procedure TEssentialsCustomNameEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIdField := 'Id';
  SetDataSet(EssentialsManager.CustomNamesManager.NamesDataset);
  FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.CustomNamesManager.NamesDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  RefreshControls(False);
end;

procedure TEssentialsCustomNameEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.customnames.PageInfo');
  AddButton := TButton.Create('essentials.customnames.add.button');
  cbPageSize := TComboBox.Create('essentials.customnames.PageSizeSelect');
  ConfirmationMsg := TMessageDlg.Create('ConfirmationMsg');
  EssentialsTable := TDBTableControl.Create('esssentials.customnames.table');
  lcPaginator := TListControl.Create('essentials.customnames.Pagination');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  ConfirmationMsg.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 185;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    ConfirmationMsg.SetParentComponent(Self);
    ConfirmationMsg.Name := 'ConfirmationMsg';
    ConfirmationMsg.Left := 33;
    ConfirmationMsg.Top := 252;
    ConfirmationMsg.Width := 24;
    ConfirmationMsg.Height := 24;
    ConfirmationMsg.ElementClassName := 'PopUpForm';
    ConfirmationMsg.Buttons := [];
    ConfirmationMsg.Opacity := 0.200000000000000000;
    ConfirmationMsg.Title := 'Confirm';
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 83;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'EntityClassName';
      Title := 'Entity';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'FieldName';
      Title := 'Field';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'CustomName';
      Title := 'Custom Name';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'IsActive';
      DataType := cdCheck;
      Title := 'Active';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnStateChange', 'DataSourceStateChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    ConfirmationMsg.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
